const INDEXABLE_HOSTS = new Set(['cassette.diy', 'www.cassette.diy']);

/** Baked at build time — controls robots.txt / sitemap / static HTML meta. */
export function allowIndexingBuild(): boolean {
  return import.meta.env.VITE_ALLOW_INDEXING === 'true';
}

/** Runtime guard: env flag + production hostname only. */
export function isIndexableSite(): boolean {
  if (!allowIndexingBuild()) return false;
  if (typeof window === 'undefined') return false;
  return INDEXABLE_HOSTS.has(window.location.hostname);
}
